import { Component, computed, inject, OnDestroy, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
interface CmsSidebarItem {
  id: string;
  label: string;
  icon: string;
  route: string;
}
@Component({
  selector: 'lib-cms-sidebar',
  standalone: true,
  imports: [NgClass],
  templateUrl: './cms-sidebar.html',
  styleUrl: './cms-sidebar.scss'
})
export class CmsSidebarComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly sub: Subscription;
  readonly items: CmsSidebarItem[] = [
    {
      id: 'services',
      label: 'Services',
      icon: 'pi-briefcase',
      route: '/services'
    },
    { id: 'products', label: 'Products', icon: 'pi-box', route: '/products' },
    { id: 'news', label: 'News', icon: 'pi-megaphone', route: '/news' }
  ];
  private readonly _currentUrl = signal(this.router.url);
  private readonly _expanded = signal(false);
  readonly expanded = this._expanded.asReadonly();
  readonly selectedItemId = computed(() => {
    const url = this._currentUrl().split('?')[0];
    return this.items.find((item) => url.startsWith(item.route))?.id ?? null;
  });
  constructor() {
    this.sub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        this._currentUrl.set((e as NavigationEnd).urlAfterRedirects);
        (document.activeElement as HTMLElement)?.blur();
      });
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  toggleExpanded(): void {
    this._expanded.update((v) => !v);
  }
  navigate(item: CmsSidebarItem): void {
    (document.activeElement as HTMLElement)?.blur();
    void this.router.navigateByUrl(item.route);
  }
  isSelected(id: string): boolean {
    return this.selectedItemId() === id;
  }
}
